import Vue from 'vue'
import App from './app.vue'
import animated from 'animate.css'
import store from './store'
var VueScrollTo = require('vue-scrollto')

Vue.use(VueScrollTo)
Vue.use(animated)

Vue.config.productionTip = false

Vue.mixin({
  data () {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    }
  },
  computed: {
    isMobile () {
      return this.windowWidth < 992
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
      this.onResize()
    })
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  },

  methods: {
    onResize () {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
    }
  }
})

new Vue({
  store,
  render: h => h(App)
}).$mount('#betaserc-m3-app')
